module.exports = VueToastr;